import { render, staticRenderFns } from "./QuickActionsEmployee.vue?vue&type=template&id=afb62bc6&scoped=true&lang=pug"
import script from "./QuickActionsEmployee.vue?vue&type=script&lang=ts"
export * from "./QuickActionsEmployee.vue?vue&type=script&lang=ts"
import style0 from "./QuickActionsEmployee.vue?vue&type=style&index=0&id=afb62bc6&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afb62bc6",
  null
  
)

export default component.exports